/**
 * MissionLogGallery — lists available mission logs for replay.
 */

import { useEffect, useState } from "react";

const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8787";

interface LogEntry {
  sessionId: string;
  createdAt: number;
}

interface Props {
  onSelect: (sessionId: string) => void;
  onBack: () => void;
}

export function MissionLogGallery({ onSelect, onBack }: Props) {
  const [logs, setLogs] = useState<LogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/mission-logs`)
      .then((r) => r.json())
      .then((data) => {
        setLogs(data.logs ?? []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="log-gallery">
      <div className="log-gallery-title">MISSION LOGS</div>
      <div className="log-gallery-sub">SELECT A MISSION TO REPLAY</div>

      <div className="log-gallery-list">
        {loading && (
          <div className="log-gallery-empty">SCANNING ARCHIVES...</div>
        )}

        {!loading && logs.length === 0 && (
          <div className="log-gallery-empty">NO MISSION LOGS FOUND</div>
        )}

        {logs.map((log) => (
          <div
            key={log.sessionId}
            className="log-gallery-item"
            onClick={() => onSelect(log.sessionId)}
          >
            <span className="log-gallery-item-id">
              {log.sessionId.slice(0, 8).toUpperCase()}
            </span>
            <span className="log-gallery-item-date">
              {new Date(log.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          </div>
        ))}
      </div>

      <button className="replay-btn log-gallery-back" onClick={onBack}>
        RETURN TO MAP
      </button>
    </div>
  );
}
